import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collectionsAPI } from '../../services/api';
import { collections as mockCollections } from '../../data/mock';
import { getImageUrl } from '../../utils/imageUrl';

const CollectionShowcase = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  // Sort collections: "Paintings" first, then alphabetically
  const sortCollections = (colls) => {
    return [...colls].sort((a, b) => {
      if (a.name === 'Paintings') return -1;
      if (b.name === 'Paintings') return 1;
      return a.name.localeCompare(b.name);
    });
  };

  useEffect(() => {
    const loadCollections = async () => {
      try {
        const data = await collectionsAPI.getAll();
        const rawCollections = data.length > 0 ? data : mockCollections;
        setCollections(sortCollections(rawCollections));
      } catch (error) {
        console.error('Error loading collections:', error);
        setCollections(sortCollections(mockCollections));
      } finally {
        setLoading(false);
      }
    };
    loadCollections();
  }, []);

  const featuredCollections = collections.filter(c => c.featured);

  if (loading) {
    return <div className="py-20 text-center text-gray-500">Loading collections...</div>;
  }

  return (
    <section className="bg-white">
      {featuredCollections.map((collection, index) => (
        <div 
          key={collection.id} 
          className="relative min-h-[70vh] flex items-center justify-center overflow-hidden"
        >
          {/* Background Image */}
          <div 
            className="absolute inset-0 bg-cover bg-center transform hover:scale-105 transition-transform duration-700"
            style={{ backgroundImage: `url(${getImageUrl(collection.image)})` }}
          />
          
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/20" />
          
          {/* Content Card */}
          <div className="relative z-10 bg-white/95 backdrop-blur-sm p-8 md:p-12 max-w-lg mx-4 text-center shadow-xl">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              {collection.name}
            </h2>
            <p className="text-gray-600 mb-6">
              {collection.description}
            </p>
            <Link
              to={`/collections/${collection.slug}`}
              className="inline-block px-8 py-3 border-2 border-black text-black text-sm tracking-wide hover:bg-black hover:text-white transition-all duration-300"
            >
              Shop the {collection.name.split(' ')[0]} Collection
            </Link>
          </div>
        </div>
      ))}
    </section>
  );
};

export default CollectionShowcase;
